import { Tag, TagLabel, TagRightIcon, Popover, PopoverTrigger, PopoverContent, Text, useColorModeValue } from '@chakra-ui/react'
import { InfoIcon } from '@chakra-ui/icons'
import { useTranslations } from 'next-intl'
import { FACILITIES_WITH_RELOCATION, } from "@/constants"

type Props = {
  facilityId: string
}

export const RelocationTooltip = ({ facilityId }: Props) => {
  const t = useTranslations()
  const tagColor = useColorModeValue('black', 'black')
  const popoverBg = useColorModeValue('black', 'gray.800')

  if (FACILITIES_WITH_RELOCATION.includes(facilityId)) {
    return (
      <Popover>
        <PopoverTrigger>
          <Tag py={1} px={2} bg="blue.100" cursor="pointer" fontSize={'10px'}>
            <TagLabel color={tagColor}>{t('hardware-list.pending-relocation.title')}</TagLabel>
            <TagRightIcon as={InfoIcon} color="blue.500" />
          </Tag>
        </PopoverTrigger>
        <PopoverContent minWidth={'340px'} p={1} textAlign='center' fontSize={'xs'} fontWeight={400} bg={popoverBg} color='white' borderRadius="md">
          <Text>{t.rich('hardware-list.pending-relocation.description', { br: () => <br /> })}</Text>
        </PopoverContent>
      </Popover>
    )
  }

  return null
}
